module.exports = __webpack_public_path__ + "static/0040-05ebb31521a37dcd26280d3eae51bcba.png";